import { createAsyncThunk } from '@reduxjs/toolkit';

import { authSet } from '../../../utils/request';
import { METHOD_PATCH } from '../../../constants/api';
import { setWarehouseParts } from '../../../actions/coilovers/warehouse/patchWarehouse';

const patchWarehouse = createAsyncThunk('warehouse/patchWarehouse',
  async ({ _id, formData }, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await authSet(METHOD_PATCH, `/co/warehouse/${_id}`, formData);
      dispatch(setWarehouseParts(data));
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  });

export default patchWarehouse;
